declare global {

    interface ApiConfigurationWithKey {
        url: string,
        apiKey: string
    }

    interface ApiConfigurationWithKeyRef {
        url: string,
        apiKeyRef: string
    }

    interface GlobalConfiguration {
        aromConnector: ApiConfigurationWithKey | ApiConfigurationWithKeyRef,
        events: ApiConfigurationWithKey | ApiConfigurationWithKeyRef,
        fabrication: ApiConfigurationWithKey | ApiConfigurationWithKeyRef,
        preparation: ApiConfigurationWithKey | ApiConfigurationWithKeyRef,
        prices: ApiConfigurationWithKey | ApiConfigurationWithKeyRef,
        products: ApiConfigurationWithKey | ApiConfigurationWithKeyRef,
        stores: ApiConfigurationWithKey | ApiConfigurationWithKeyRef,
        
        keycloakUrl: string;
        keycloakRealm: string;
        keycloakClientId: string;
    }

    interface Window {
        configuration: GlobalConfiguration;
    }
}

export default window.configuration;
